import * as actions from './actionTypes';


export const fetchFile = (url:string) => {
	return {
		type: actions.FETCH_FILE,
		payload: url
	}
}

// handles offer PDF fetching from api
export const fetchOfferPDF = (id:number) => {
	return {
		type: actions.FETCH_OFFER_PDF,
		payload: id
	}
}

export const fetchVPNOfferPDF = (id:number) => {
	return {
		type: actions.FETCH_VPN_OFFER_PDF,
		payload: id
	}
}

export const fetchMDSReport = (id:number) => {
	return {
		type: actions.FETCH_MDS_REPORT,
		payload: id
	}
}

// global success|error actions for handling files
export const fileSuccess = (file:Blob) => {
	return {
		type: actions.FILE_SUCCESS,
		payload: file
	}
}

export const fileError = (err:string) => {
	return {
		type: actions.FILE_ERROR,
		payload: err
	}
}

export const fileRemove = () => {
	return {
		type: actions.FILE_REMOVE,
	}
}